import { LwFormMultiSelect } from 'redesign';
import { useFormContext } from 'react-hook-form';
import { Props, WorkTemplateCertificatesFormContext } from './work-template-certificates.types';

export const WorkTemplateCertificatesSelect = (props: Props) => {
  const { control } = useFormContext<WorkTemplateCertificatesFormContext>();
  const formName = 'jobCertificates';
  const label = 'Aanvullende certificaten';

  return (
    <LwFormMultiSelect
      name={formName}
      control={control}
      options={props.options}
      disabled={props.disabled}
      isOptionEqualToValue={(option, value) => option.id === value.id}
      getOptionKey={(option) => option.id}
      getOptionLabel={(option) => {
        return option.name;
      }}
      label={label}
      onChange={props.onChange}
    />
  );
};
